export enum AutomationHubItemId {
  AutoProfiling = '1',
  GeoLocation = '2',
  BusinessCardScan = '3',
  InAppLiveChat = '4',
  Evolution = '5',
  PandaDoc = '6',
  MSExchangeEmail = '7',
  MSExchangeContacts = '8',
  MSExchangeAppointments = '9',
  MSExchangeTasks = '10',
  GoogleGmail = '11',
  GoogleContacts = '12',
  GoogleCalendar = '13',
  GoogleTasks = '14',
  IMAPEmail = '16',
  MSSharepoint = '18',
  Dropbox = '22',
  Office365Contacts = '40',
  Office365Calendar = '41',
  Office365Tasks = '42',
  Office365Email = '43',
  GoogleDrive = '45',
  SQLExports = '63',
  Jira = '64',
  RevenueScheduling = '65',
  Calling = '66',
  Projects = '67',
  Alfresco = '68',
  EmailSequences = '69',
  AccountHealth = '70',
  Hubspot = '71',
  AppointmentsScheduler = '72',
  MSTeams = '73',
  Zoom = '74',
  AdvancedPermissions = '75',
  DocumentManagement = '76',
  CustomEntityNames = '77',
  LeadScoring = '78',
  OneDrive = '79',
  Targets = '80',
  MultilanguageSupport = '81',
  Quotes = '82',
  ApprovalProcesses = '83',
  Zendesk = '84',
  Salesforce = '90',
  AIVoyagerOne = '85',
  AIVoyagerTwo = '108',
  AIEmailAssistant = '1000',
  AITextTools = '1001',
  AITextAnalysis = '1002',
  AIFeedTools = '1003',
  AITextToSpeech = '1004',
  AISpeechToText = '89',
  AIMediaTranscription = '100',
  AIOnlineFormAgent = '1007',
  AIReportAgent = '1008',
  OnlineForms = '86',
  CustomEntities = '87',
  ApiAccess = '91',
  Automatizer = '777',
  LocationTracking = '93',
  DuplicateChecker = '95',
  DomainExtractor = '96',
  Sendgrid = '97',
  WhatsApp = '98',
  FieldMapping = '101',
  MsDynamics = '102',
  ProductPricing = '106'
}

export interface AutomationHubItemDoc {
  helpURL: string;
}

export const AutomationHubItemDocs: Partial<{ [key in AutomationHubItemId]: AutomationHubItemDoc }> = {
  [AutomationHubItemId.CustomEntities]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/8330709-advanced-admin-working-with-custom-entities'
  },
  [AutomationHubItemId.AccountHealth]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5609036-account-management-using-account-health-in-pipeliner'
  },
  [AutomationHubItemId.AdvancedPermissions]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5917372-user-roles-working-with-advanced-user-permissions'
  },
  [AutomationHubItemId.OnlineForms]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/8039971-working-with-online-forms'
  },
  [AutomationHubItemId.AIVoyagerOne]: {
    helpURL: 'https://help.pipelinersales.com/en/?q=ai'
  },
  [AutomationHubItemId.AIVoyagerTwo]: {
    helpURL: 'https://help.pipelinersales.com/en/?q=ai'
  },
  [AutomationHubItemId.ApprovalProcesses]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/7327298-working-with-approval-processes'
  },
  [AutomationHubItemId.AppointmentsScheduler]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5882803-appointment-scheduler'
  },
  [AutomationHubItemId.AutoProfiling]: {
    helpURL: 'https://www.pipelinersales.com/crm/apps/fullcontact'
  },
  [AutomationHubItemId.Automatizer]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3834789-automatizer-creating-and-running-processes'
  },
  [AutomationHubItemId.SQLExports]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/4085771-bi-feeder-exporting-pipeliner-data-to-use-with-bi-solutions'
  },
  [AutomationHubItemId.BusinessCardScan]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728955-using-the-business-card-scanner'
  },
  [AutomationHubItemId.Calling]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6444835-calling-text-messaging-call-or-send-text-messages-from-within-the-pipeliner-app'
  },
  [AutomationHubItemId.CustomEntityNames]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6109263-advanced-set-up-custom-entity-names'
  },
  [AutomationHubItemId.DocumentManagement]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6109257-document-management'
  },
  [AutomationHubItemId.Dropbox]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3368508-how-to-enable-and-use-the-dropbox-integration-to-pipeliner-cloud'
  },
  [AutomationHubItemId.EmailSequences]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5694513-using-email-sequences-in-pipeliner'
  },
  [AutomationHubItemId.GeoLocation]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3171045-how-to-use-the-map-view-for-accounts-contacts-lead-and-opportunities'
  },
  [AutomationHubItemId.GoogleCalendar]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2724425-integrating-your-google-calendar-with-pipeliner-crm'
  },
  [AutomationHubItemId.GoogleContacts]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2724429-integrating-your-google-contacts-with-pipeliner-crm'
  },
  [AutomationHubItemId.GoogleDrive]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3175297-how-to-enable-and-use-the-google-drive-integration-to-pipeliner-cloud'
  },
  [AutomationHubItemId.GoogleGmail]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2724420-integrating-your-gmail-with-pipeliner-crm'
  },
  [AutomationHubItemId.GoogleTasks]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2724404-integrating-your-google-tasks-with-pipeliner-crm'
  },
  [AutomationHubItemId.Hubspot]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5996656-how-to-enable-and-use-the-hubspot-integration-to-pipeliner'
  },
  [AutomationHubItemId.InAppLiveChat]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728995-how-to-contact-pipeliner-s-support-team'
  },
  [AutomationHubItemId.IMAPEmail]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2864162-integrating-email-to-pipeliner-using-imap'
  },
  [AutomationHubItemId.Jira]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/4096964-how-to-enable-and-use-the-jira-integration-to-pipeliner'
  },
  [AutomationHubItemId.LeadScoring]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6444841-working-with-leads-using-lead-scoring'
  },
  [AutomationHubItemId.MSExchangeAppointments]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728988-exchange-email-integration-errors-identifying-and-resolving-the-problems'
  },
  [AutomationHubItemId.MSExchangeContacts]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728988-exchange-email-integration-errors-identifying-and-resolving-the-problems'
  },
  [AutomationHubItemId.MSExchangeEmail]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728988-exchange-email-integration-errors-identifying-and-resolving-the-problems'
  },
  [AutomationHubItemId.MSExchangeTasks]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2728988-exchange-email-integration-errors-identifying-and-resolving-the-problems'
  },
  [AutomationHubItemId.MSSharepoint]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2948943-how-to-enable-and-use-the-office-365-sharepoint-online-integration-to-pipeliner-cloud'
  },
  [AutomationHubItemId.MSTeams]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5920210-how-to-enable-and-use-the-microsoft-teams-video-calling-integration-to-pipeliner'
  },
  [AutomationHubItemId.MultilanguageSupport]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6752008-multilanguage-support'
  },
  [AutomationHubItemId.Office365Calendar]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3322363-integrating-your-microsoft-365-office-365-appointments-with-pipeliner-crm'
  },
  [AutomationHubItemId.Office365Contacts]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3878571-integrating-your-microsoft-365-office-365-contacts-with-pipeliner-crm'
  },
  [AutomationHubItemId.Office365Email]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3367898-microsoft-365-office-365-outlook-email-integration'
  },
  [AutomationHubItemId.Office365Tasks]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6652681-office-365-tasks-integration'
  },
  [AutomationHubItemId.OneDrive]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/3334713-microsoft-365-office-365-using-templates-with-word-and-excel'
  },
  [AutomationHubItemId.PandaDoc]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/2800370-how-to-enable-and-use-the-pandadoc-integration-to-pipeliner'
  },
  [AutomationHubItemId.Projects]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5535839-project-management-using-projects-in-pipeliner'
  },
  [AutomationHubItemId.Quotes]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6912065-quotes-creating-and-managing-quotes'
  },
  [AutomationHubItemId.RevenueScheduling]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/4293948-using-opportunity-revenue-recognition'
  },
  [AutomationHubItemId.Targets]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/6752004-targets-tracking-the-sales-performance-of-users-or-teams'
  },
  [AutomationHubItemId.Zoom]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/5919899-how-to-enable-and-use-the-zoom-video-calling-integration-to-pipeliner'
  },
  [AutomationHubItemId.LocationTracking]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/9065498-location-tracking-tracking-activities-based-on-their-location'
  },
  [AutomationHubItemId.DuplicateChecker]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/9311395-managing-data-using-the-duplicate-checker'
  },
  [AutomationHubItemId.Sendgrid]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/9618924-email-integration-using-twilio-sendgrid'
  },
  [AutomationHubItemId.WhatsApp]: {
    helpURL: 'https://help.pipelinersales.com/en/articles/9991897-pipeliner-whatsapp-messaging-integration'
  }
};
